import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/notifications');
  return response.data;
}
async function paginate(params = {}) {
  let response = await axiosAuth.get('/notifications/paginate', { params });
  return response.data;
}
async function markAsRead(data) {
  let response = await axiosAuth.post('/notifications/mark-as-read', data);
  return response.data;
}

export default {
  index,
  markAsRead,
  paginate,
};
